module.exports = __webpack_public_path__ + "aea256e72852bd3eb6706c703f0a4ceb.svg";